import { useState } from 'react';
import './Header.css';
import LocalLink from './LocalLink';
import background from './img/BANNER.png';
import MediaQuery from 'react-responsive';

function Header() {
    const [showLinks, setShowLinks] = useState(false);

    return <div className='header' id='header'>
        <img src={background} alt="banner"/>
        <div>
            <MediaQuery minWidth={1100} >
                <h1>
                    Abenteuer
                    <br/>
                    pakete.de
                </h1>
                <div>
                    <LocalLink to="/">Home</LocalLink>
                    <a href="http://abenteuerpaketeshop.de">Shop</a>
                    <LocalLink to="/guestbook">Gästebuch</LocalLink>
                    <LocalLink to="/about">Über Uns</LocalLink>
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={1100}>
                <h1/>
                <div>
                    <i className='pi pi-bars menu' onClick={() => setShowLinks(true)} />
                </div>
                {showLinks && <div className='fullscreen header-links'>
                    <i className='pi pi-arrow-right' onClick={() => setShowLinks(false)} />
                    <LocalLink onClick={() => setShowLinks(false)} to="/">Home</LocalLink>
                    <a href="http://abenteuerpaketeshop.de">Shop</a>
                    <LocalLink onClick={() => setShowLinks(false)} to="/guestbook">Gästebuch</LocalLink>
                    <LocalLink onClick={() => setShowLinks(false)} to="/about">Über Uns</LocalLink>
                </div>}
            </MediaQuery>
        </div>
    </div>
}

export default Header;